import { useEffect } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'bookem-widget': {
        'business-id': string;
      };
    }
  }
}

const BookemWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://embed.bookem.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <bookem-widget business-id="0734f2a4299347d0a0497b66c23f689c" />
  );
};

export default BookemWidget;